import axios from "axios";


function configureApeAPI(options) {
    const apiUrl = `${options.baseUrl}/ape`;

    return {
        async getApeCodes(apeCode) {
            const response = await axios.get(`${apiUrl}/get-ape-codes`, {
                params: {"ape-code": apeCode}
            });
            return response.data.content;
        },
        async getConventions(apeCode) {
            const response = await axios.get(`${apiUrl}/get-conventions`, {
                params: {"ape-code": apeCode}
            });
            return response.data.content;
        }
    };
}

export { configureApeAPI };